import { useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Wallet, TrendingUp, History, Bell } from "lucide-react";

const ITEMS = [
  { label: "Главная", icon: LayoutDashboard, path: "/dashboard" },
  { label: "Кошелёк", icon: Wallet, path: "/wallet" },
  { label: "Рынок", icon: TrendingUp, path: "/market" },
  { label: "История", icon: History, path: "/history" },
  { label: "Уведомл.", icon: Bell, path: "/notifications" },
];
const PATHS = ITEMS.map((i) => i.path);

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Only show on the primary tabbed routes
  if (!PATHS.includes(pathname)) return null;

  return (
    <>
      {/* in-flow spacer so content clears the fixed bar on mobile */}
      <div className="lg:hidden h-20" aria-hidden="true" />
      <nav
        className="lg:hidden fixed bottom-0 inset-x-0 z-[60] h-16 bg-[#000000]/95 border-t border-[#1F1F1F] flex items-stretch justify-around px-1"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        data-testid="mobile-bottom-nav"
      >
        {ITEMS.map((it) => {
          const Icon = it.icon;
          const active = pathname === it.path;
          return (
            <button
              key={it.path}
              onClick={() => navigate(it.path)}
              className={`relative flex-1 flex flex-col items-center justify-center gap-1 min-w-0 transition-colors ${
                active ? "text-[#FF8A1E]" : "text-[#71717A]"
              }`}
              data-testid={`bottomnav-${it.path.slice(1)}`}
            >
              {active && (
                <span className="absolute top-0 h-0.5 w-8 rounded-full bg-[#FF8A1E]" />
              )}
              <Icon size={22} />
              <span className="text-[10px] font-medium truncate max-w-full px-0.5">{it.label}</span>
            </button>
          );
        })}
      </nav>
    </>
  );
};

export default MobileBottomNav;
